import translateProps from "MODULES/shared/decorators/translateProps";
import { Row } from "react-bootstrap";

export default translateProps(() => ({
  className: "row-col-gutters-half"
}))(Row);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormRow.jsx